import { useAuth } from '@/composables/auth'
import { env } from '@/env'
import { computed } from 'vue'
import { useConfig } from '@/composables/game/config'

export const useReferral = () => {
  const { config } = useConfig()

  const { profile } = useAuth()
  const referralUrl = computed(() => `https://t.me/${env.bot.username}/${env.bot.appShortName}?startapp=ref_${profile.value.referralCode}`)
  const shareUrl = computed(() => {
    const shareUrl = new URL('https://t.me/share/url')
    shareUrl.searchParams.set('url', referralUrl.value)
    shareUrl.searchParams.set('text', env.bot.shareText.replace(/%normal_reward%/g, String(config.value.game.referrals.initialRefereeReward.normal)).replace(/%premium_reward%/g, String(config.value.game.referrals.initialRefereeReward.premium)))
    return shareUrl.toString().replace(/\+/g, '%20')
  })

  return {
    shareUrl,
    referralUrl,
  }
}
